export default function styles() {
  return {
    overrideLayout: {
      height: '80vh',
    },
  }
}
